// API配置文件
export const API_BASE_URL = 'https://d1-mysql-manager-api.5212025.xyz';

// API端点配置
export const API_ENDPOINTS = {
  auth: {
    login: '/api/auth/login',
    logout: '/api/auth/logout',
    verify: '/api/auth/verify'
  },
  users: '/api/users',
  roles: '/api/roles',
  connections: '/api/connections',
  tables: '/api/tables',
  permissions: '/api/permissions',
  audit: '/api/audit',
  dashboard: '/api/dashboard'
};

// 完整URL构建函数
export const buildApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
}; 